<app-layout>
  <div class="row">
    <div class="col-12" *ngIf="kullanici">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{id === '0' ? 'Yeni Kullanıcı' : 'Kullanıcı Düzenle'}}</h4>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()">
              Kaydet
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Kullanıcı Adı</div>
                <input type="text" class="form-control" placeholder="Kullanıcı Adı"
                       [(ngModel)]="kullanici.kullaniciAdi">
              </div>
              <div class="mb-3">
                <div class="form-label">Ad Soyad</div>
                <input type="text" class="form-control" placeholder="Adı Soyadı" [(ngModel)]="kullanici.adSoyad">
              </div>
              <div class="mb-3">
                <div class="form-label">E-Posta Adresi</div>
                <input type="email" class="form-control" placeholder="E-Posta Adresi" [(ngModel)]="kullanici.epostaAdresi">
              </div>
              <div class="mb-3">
                <div class="form-label">Şifre</div>
                <input type="password" class="form-control" placeholder="Şifre" [(ngModel)]="kullanici.sifre">
              </div>
              <div class="mb-3">
                <div class="form-label">VKN</div>
                <input type="text" class="form-control" placeholder="Dışarıdan bağlanacak taşımacı için" [(ngModel)]="kullanici.vkn">
              </div>
            </div>
            <div class="col-md-12 col-lg-6" *ngIf="kullaniciGrupId === 1">
              <div class="mb-3">
                <div class="form-label">Kullanıcı Grubu</div>
                <app-loading-input *ngIf="!kullanciGruplari"></app-loading-input>
                <select *ngIf="kullanciGruplari" class="form-control" [(ngModel)]="kullanici.kullaniciGrupId"
                        [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of kullanciGruplari" [ngValue]="p.id">{{p.isim}}</option>
                </select>
              </div>
              <div class="form-group mb-3">
                <label class="form-label">Şubeler</label>
                <app-loading-input *ngIf="subeler==null"></app-loading-input>
                <div *ngIf="subeler!=null">
                  <label class="form-check" *ngIf="subeler.length>1">
                    <input class="form-check-input" type="checkbox" (change)="selectAll()" [(ngModel)]="selectAllVal">
                    <span class="form-check-label">Tümünü Seç</span>
                  </label>
                  <label class="form-check" *ngFor="let sube of subeler">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sube.checked"
                           (change)="selectAllUpdate()">
                    <span class="form-check-label">{{sube.isim}}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>
